<template>
  <div class="pagamentos-edit">
    <div class="row">
      <div class="col-xs-12">
        <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
          <font-awesome-icon :icon="'arrow-left'"/>
          Voltar
        </button>
        <h2 class="page-header">Editar Pagamento</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div
          :class="['form-group', { 'has-error': errors.has('beneficiado') }]"
        >
          <label class="control-label custom-font">Beneficiado</label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'id-card'" :class="[{ 'is-danger': errors.has('beneficiado') }]" />
            </span>
            <input
              ref="beneficiado"
              v-model="item.beneficiado"
              name="beneficiado"
              placeholder="Beneficiado"
              class="form-control"
              v-validate="'required'"
              maxlength="100"
              type="text"
            />
            <div
            :class="[
                'input-group-addon custom-input-group-addon-count',
                { 'is-danger': errors.has('beneficiado') }
              ]"
              v-text="100 - item.beneficiado.length"
            ></div>
          </div>
          <small v-if="errors.has('nome')" class="help-block"
            >preenchimento obrigatório!</small
          >
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div :class="['form-group', { 'has-error': errors.has('data') }]">
          <label class="control-label custom-font">Data do Pagamento</label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'calendar-alt'" :class="[{ 'is-danger': errors.has('data') }]"/>
            </span>
            <datepicker
              v-model="item.data"
              name="data"
              ref="data"
              v-validate="'required'"
            ></datepicker>
          </div>
          <small v-if="errors.has('data')" class="help-block"
            >preenchimento obrigatório!</small
          >
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div :class="['form-group', { 'has-error': errors.has('valor') }]">
          <label class="control-label custom-font">Valor</label>
          <div class="input-group">
            <span class="input-group-addon">
              <font-awesome-icon :icon="'money-bill'" :class="[{ 'is-danger': errors.has('valor') }]"/>
            </span>
            <money
              ref="valor"
              name="valor"
              v-model="item.valor"
              class="form-control"
              v-validate="'required'"
              v-bind="money"
            />
          </div>
          <small v-if="errors.has('valor')" class="help-block"
            >preenchimento obrigatório!</small
          >
        </div>
      </div>
      <section v-if="cd_beneficios_periodo.includes(item.cd_beneficio)">
        <div class="col-xs-12 col-sm-6">
          <div
            :class="['form-group', { 'has-error': errors.has('periodoini') }]"
          >
            <label class="control-label custom-font">Início do Período</label>
            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon :icon="'calendar-alt'" :class="[{ 'is-danger': errors.has('periodoini') }]"/>
              </span>
              <datepicker
                v-model="item.periodo_inicio"
                name="periodoini"
                ref="periodoini"
                v-validate="'required'"
              ></datepicker>
            </div>
            <small v-if="errors.has('periodoini')" class="help-block"
              >preenchimento obrigatório!</small
            >
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div
            :class="['form-group', { 'has-error': errors.has('periodofim') }]"
          >
            <label class="control-label custom-font">Fim do Período</label>
            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon :icon="'calendar-alt'" />
              </span>
              <datepicker
                v-model="item.periodo_fim"
                name="periodofim"
                ref="periodofim"
                v-validate="'required'"
              ></datepicker>
            </div>
            <small v-if="errors.has('periodofim')" class="help-block"
              >preenchimento obrigatório!</small
            >
          </div>
        </div>
      </section>
      <div class="col-xs-12 col-sm-6">
        <div :class="['form-group', { 'has-error': errors.has('beneficio') }]">
          <label class="control-label custom-font">Benefício</label>
          <select
            ref="beneficio"
            class="form-control"
            name="beneficio"
            v-model="item.cd_beneficio"
            v-validate="'required'"
          >
            <option
              v-for="item in beneficios"
              :key="item.codigo"
              :value="item.codigo"
            >
              {{ item.sigla }}
            </option>
          </select>
          <small v-if="errors.has('beneficio')" class="help-block"
            >preenchimento obrigatório!</small
          >
        </div>
      </div>
      <div class="form-group col-xs-12 margem-topo">
        <button
          @click.prevent="salvar()"
          class="btn btn-default"
          :disabled="carregando"
        >
          <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/request'
import datepicker from '@/components/common/Datepicker'

export default {
  components: { datepicker },
  data() {
    return {
      item: {},
      carregando: false,
      dtpagamento: null,
      cd_beneficios_periodo: [1, 5, 7],
      beneficios: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    handleLoading() {
      this.carregando = !this.carregando
    },
    salvar() {
      this.handleLoading()

      request
        .post('assistencia/pagamentos/salvar', [this.item])
        .then(({ data }) => {
          this.$toastr.s(data.msg)
          this.$router.push('/admin/assistencia/pagamentos')
        })
        .catch(({ response }) => {
          this.$toastr.e(response.data.msg)
        })
        .then(() => {
          this.handleLoading()
        })
    }
  },
  beforeCreate() {
    if (!this.$route.params.item) {
      this.$router.push('/admin/assistencia/pagamentos')
      return
    }

    request
      .get('/assistencia/listar-beneficios')
      .then(({ data }) => {
        this.beneficios = [...data]
      })
      .catch(error => {
        this.$toastr.e(
          'Houve um erro no carregamento de benefícios. Atualize a página e tente novamente.'
        )
        console.log(error)
      })
  },
  created() {
    this.item = { ...this.$route.params.item }
  }
}
</script>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}
.custom-input-group-addon-count {
  color: #00615c;
}
.fa-id-card {
  color: #00615c;
}
.fa-calendar-alt {
  color: #00615c;
}
.fa-money-bill {
  color: #00615c;
}
.custom-input-group-addon-count.is-danger {
  color: #990000;
}
.fa-id-card.is-danger {
  color: #990000;
}
.fa-calendar-alt.is-danger {
  color: #990000;
}
.fa-money-bill.is-danger {
  color: #990000;
}
.btn-voltar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/assistencia/pagamentos/Edit.vue